import type { Post } from '@/@types/post'
import Modal from '@/components/Modal'
import { css } from '@emotion/react'
import { CloseIcon } from '@ruguoapp/jike-fe-icons'
import { type HTMLAttributes, useCallback } from 'react'
import RepostForm from './RepostForm'
import {
	resetRepostTarget,
	setIsRepostFormModalShow,
	setRepostTarget,
	useIsRepostFormModalShow,
	useRepostTarget,
} from './state'

export interface RepostFormModalProps
	extends Omit<HTMLAttributes<HTMLDivElement>, 'defaultValue'> {}

export default function RepostFormModal({ ...props }: RepostFormModalProps) {
	const [isShow, setIsShow] = useIsRepostFormModalShow()
	const [target] = useRepostTarget()

	const handleClose = useCallback(async () => {
		setIsShow(false)
	}, [setIsShow])

	return (
		<Modal
			isShow={isShow && !!target}
			onClose={handleClose}
			onExitTransitionEnd={() => {
				resetRepostTarget()
			}}
			backdrop
			header={
				<>
					<div
						css={css`
							display: flex;
							width: fit-content;
							cursor: pointer;
						`}
						onClick={handleClose}
					>
						<CloseIcon
							css={css`
								width: 24px;
								aspect-ratio: 1;
							`}
						/>
					</div>
					<div
						css={css`
							justify-content: center;
						`}
					>
						转发动态
					</div>
					<div />
				</>
			}
			css={css`
				.jk-modal-container {
					overflow: hidden;
					margin-top: 5%;
					height: fit-content;
				}
			`}
		>
			<RepostForm
				target={target!}
				onSubmit={handleClose}
				css={css`
					padding: unset;

					textarea {
						min-height: 200px;
					}
				`}
			/>
		</Modal>
	)
}

export function useRepostFormModal() {
	const open = useCallback((target: Post) => {
		setRepostTarget(target)
		setIsRepostFormModalShow(true)
	}, [])

	const close = useCallback(() => {
		setIsRepostFormModalShow(false)
		setRepostTarget(null)
	}, [])

	return {
		open,
		close,
	}
}
